export const fnormalizedRadius = (radius:number, stroke: number) => radius - stroke * 2;
export const fcircumference = (normalizeRadius: number) => normalizeRadius * 2 * Math.PI;
export const fstrokeDashoffset = (
  circumFerence: number,
  progress: number,
) => circumFerence - progress / 100 * circumFerence;
